import request from "../utils/request";
import { normalizePaginationInteger, type PaginationIntegerValue } from "./pagination";

export interface DocumentSyncLogItem {
  ID: string;
  SyncTime: string;
  ScannedCount: string;
  AddedCount: string;
  RetriedCount: string;
  FailedCount: string;
  UpdatedCount: string;
  SkippedCount: string;
  DeletedCount: string;
  Operator?: string;
  DataSource?: string[] | string;
  // 源端级错误（预检失败 / 站点或子目录遍历异常），与逐文件 FailedDetails 区分
  SourceError?: string[] | string;
  FailedDetails?: DocumentSyncLogFailureItem[];
  AddedDetails?: DocumentSyncLogFileItem[];
  RetriedDetails?: DocumentSyncLogFileItem[];
  UpdatedDetails?: DocumentSyncLogFileItem[];
  DeletedDetails?: DocumentSyncLogFileItem[];
}

export interface DocumentSyncLogFailureItem {
  FileName?: string;
  Reason?: string;
  SrcDocumentId?: string;
  DocumentGuid?: string;
  SourcePathAskId?: string | null;
  SourcePath?: string;
  IsReviewed?: boolean;
  ReviewedAt?: string | null;
  ReviewedBy?: string | null;
  // true 表示 retry 后再次失败的记录：仅用于把它从 Succeeded 中剔除，不展示为失败、不计入失败数。
  Suppressed?: boolean;
}

export interface DocumentSyncLogFileItem {
  FileName?: string;
  SrcDocumentId?: string;
  DocumentGuid?: string;
  SourcePathAskId?: string | null;
  SourcePath?: string;
}

export type DocumentSyncLogStatusFilter = "succeeded" | "failed";
export type DocumentSyncLogReviewFilter = "reviewed" | "unreviewed";

export interface DocumentSyncLogSearchParams {
  Keyword?: string;
  Status?: DocumentSyncLogStatusFilter;
  FailedReviewStatus?: DocumentSyncLogReviewFilter;
  Page?: number;
  Limit?: number;
}

export interface DocumentSyncLogSearchResponse {
  Count: number;
  Page: number;
  Limit: number;
  Data: DocumentSyncLogItem[];
}

interface DocumentSyncLogSearchWire {
  Count?: PaginationIntegerValue;
  Page?: PaginationIntegerValue;
  Limit?: PaginationIntegerValue;
  Data?: DocumentSyncLogItem[];
}

export async function searchDocumentSyncLogs(params: DocumentSyncLogSearchParams) {
  const response = await request.post<DocumentSyncLogSearchWire>(
    "/project/documentsynclog/search",
    params,
  );
  const body = response.data ?? {};
  const data = {
    Count: normalizePaginationInteger(body.Count, 0, 0),
    Page: normalizePaginationInteger(body.Page, params.Page ?? 1, 1),
    Limit: normalizePaginationInteger(body.Limit, params.Limit ?? 20, 1),
    Data: body.Data ?? [],
  } satisfies DocumentSyncLogSearchResponse;
  return { ...response, data };
}

export interface LatestDocumentSyncLogResponse {
  UpdateTime: string | null;
}

export function getLatestDocumentSyncLog() {
  return request.get<LatestDocumentSyncLogResponse>("/project/documentsynclog/latest");
}

export interface MarkFailedReviewedParams {
  LogId: string;
  DocumentGuid?: string;
  SrcDocumentId?: string;
  FileName?: string;
  IsReviewed: boolean;
}

export interface MarkFailedReviewedResponse {
  LogId: string;
  SrcDocumentId?: string | null;
  FileName?: string | null;
  IsReviewed: boolean;
  ReviewedAt?: string | null;
  ReviewedBy?: string | null;
}

export function markDocumentSyncLogFailedReviewed(params: MarkFailedReviewedParams) {
  return request.post<MarkFailedReviewedResponse>(
    "/project/documentsynclog/markfailedreviewed",
    params,
  );
}
